module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/89dcd810c06d1dce0b6113e84bc6d1f1.png";